module.exports = __webpack_public_path__ + "static/media/ISCAP.938879a4.png";